import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CmsPageAdapter,
  CmsPageConnector,
  CmsStructureConfigService,
  CmsStructureModel,
  GlobalMessageService,
  GlobalMessageType,
  PageContext,
  RoutingService,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

declare module '@spartacus/core' {
  interface Page {
    localizedLabel?: string;
  }
}

@Injectable({
  providedIn: 'root',
})
export class CustomCmsPageConnector extends CmsPageConnector {
  constructor(
    protected location: Location,
    protected globalMessageService: GlobalMessageService,
    protected routingService: RoutingService,
    cmsPageAdapter: CmsPageAdapter,
    cmsStructureConfigService: CmsStructureConfigService
    // @Optional() @Inject(RESPONSE) private response: Response
  ) {
    super(cmsPageAdapter, cmsStructureConfigService);
  }

  override get(pageContext: PageContext): Observable<CmsStructureModel> {
    return this.cmsStructureConfigService.shouldIgnoreBackend(pageContext.id).pipe(
      switchMap((loadFromConfig) => {
        if (!loadFromConfig) {
          return this.cmsPageAdapter.load(pageContext).pipe(
            catchError((error) => {
              if (error instanceof HttpErrorResponse && error.status === 400) {
                return of({});
                // } else if (error instanceof HttpErrorResponse && error.status === 404) {
                //   // console.log('404', pageContext, error);
                //   return of({ status: 404, id: pageContext.id });
              } else if (error instanceof HttpErrorResponse && error.status === 500) {
                // backend: page not available in language
                if (error.error.errors.some((item) => item.errorCode === 'HIS-401')) {
                  this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
                  this.routingService.go('/');
                }
                return of({});
              } else {
                throw error;
              }
            })
          );
        } else {
          return of({});
        }
      }),
      switchMap((page) => {
        return this.mergeDefaultPageStructureOOTB(pageContext, page);
      })
    );
  }

  private mergeDefaultPageStructureOOTB(
    pageContext: PageContext,
    pageStructure: CmsStructureModel
  ): Observable<CmsStructureModel> {
    return this.cmsStructureConfigService.mergePageStructure(pageContext.id, pageStructure);
  }
}
